<div class="w-100 h-100">
  <router-outlet></router-outlet>
</div>
